<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { ref } from "vue";
import BookingForm from "@/components/regularComponents/FormComponents/BookingForm.vue";

defineProps<{
  title?: string;
}>();

const templateKey = ref(0);
</script>

<template>
  <div class="are-you-interested__form" :key="templateKey">
    <h2 class="are-you-interested__form-title uppercase">{{ title }}</h2>
    <BookingForm :dontPushQuery="true" @close="templateKey++" @update="" hideCheckbox eventFormType="Send request" />
  </div>
</template>
